// extracted by mini-css-extract-plugin
export default {"wrapper":"sfa","container":"tfa","title":"ufa","desc":"vfa","usage":"wfa","box":"xfa","subtitle":"yfa","ingredients":"zfa","carousel":"Afa","ingredientscarousel":"Bfa","productinfo":"Cfa","ingredientsinfo":"Efa"};
    if(module.hot) {
      // 1721922369182
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  